export default {
  accrualSummary: {
    absenceDates: 101715, // Absence Dates
    accrualFilter: 101207, // Accrual Filter
    assignedBenefitPackage: 101864, // Assigned Benefit Package
    balanceDetails: 102210, // Balance Details
    balances: 84026, // Balances
    balanceBreakdown: 101687, // Balance Breakdown
    balanceSummary: 101721, // Balance Summary
    calculateFutureBalance: 102054, // Calculate Future Balance
    currentBalance: 91530, // Current Balance
    expectedBalance: 100911, // Expected Balance
    futureAbsences: 102056, // Future Absences
    futureBalanceCalculation: 102052, // Future Balance Calculation
    futureBalanceCalculationBreakdown: 102053, // Future Balance Calculation Breakdown
    viewBalanceDetails: 102215, // View Balance Details
    who: 46253, // Who
  },
};
